import { identificationType, panelType } from '../../../shared/constants';
import createPropsForScopusArticle from './createPropsForScopusArticle';
import createPropsForXocsArticle from './createPropsForXocsArticle';

const articlePreviewPanel = panelType.citedByArticlePreview;

const scopusArticlesSelector = ({ data }) => data;
const scopusProcessor = {
  createArticleProps: (citingArticlesState, index) => createPropsForScopusArticle(
    scopusArticlesSelector(citingArticlesState)[index],
  ),
  createArticleListProps: citingArticlesState => scopusArticlesSelector(citingArticlesState)
    .map(createPropsForScopusArticle)
    .map((props, index) => ({
      ...props,
      key: props.doi,
      articlePreviewPanel,
      articlePreviewProps: { index },
    })),
};

const xocsArticlesSelector = ({ data: { citingArticles } }) => citingArticles;
const xocsProcessor = {
  createArticleProps: (citingArticlesState, index) => createPropsForXocsArticle(
    xocsArticlesSelector(citingArticlesState)[index],
  ),
  createArticleListProps: citingArticlesState => xocsArticlesSelector(citingArticlesState)
    .map(createPropsForXocsArticle)
    .map((props, index) => ({
      ...props,
      key: props.pii,
      articlePreviewPanel,
      articlePreviewProps: { index },
    })),
};

const processorMap = {
  [identificationType.doi]: scopusProcessor,
  [identificationType.pii]: xocsProcessor,
};

export default function getCitedByProcessor(idType) {
  return processorMap[idType];
}
